import styled from 'styled-components';
import { ListGroupItem, Table } from 'reactstrap';
import { cssSizes } from '../../Common.style';
import { Row } from 'reactstrap';

const CustomListGroupItem = styled(ListGroupItem)`
  border: none !important;
`;

const CenterRow = styled(Row)`
  justify-content: center;
  width: 100%;
  margin: 0;
  padding: 20px 0;
`;

const CustomTable = styled(Table)`
  width: 100%;
  max-width: none;
  margin: 0;
  background-color: transparent;
  border: none;

  thead {
    th {
      border: none;
      padding: 16px 20px;
      font-weight: 700;
      color: var(--rr-ink-muted);
      text-align: center;
      font-size: 14px;
      letter-spacing: 0.5px;
      text-transform: uppercase;
      background-color: var(--rr-surface);
      position: sticky;
      top: 0;
      z-index: 2;
      box-shadow: inset 0 -1px 0 #d8d8d8;
    }
  }

  tbody {
    tr {
      border: none;
      background-color: transparent;

      td {
        padding: 2px 20px;
        text-align: center;
        vertical-align: middle;
        border: none;
        border-top: 1px solid #d8d8d8;
        font-size: 16px;
        line-height: 1.5;
        background-color: transparent;

        div {
          font-weight: 500;
          color: var(--rr-ink);
        }

        span {
          color: var(--rr-ink);
          font-size: 14px;
          font-style: normal;
        }
      }
    }
  }

`;

const TDPadding = styled.td`
  width: 20px !important;
  padding: 0 !important;
  border: none !important;

  ${cssSizes.phoneLandscape`
    width: 10px !important;
  `}

  ${cssSizes.tabletLandscape`
    width: 20px !important;
  `}
`;

const PreferenceNumber = styled.span`
  color: var(--rr-ink);
  font-weight: 600;
  font-size: 16px;
  display: inline-block;
`;

export { CustomListGroupItem, CenterRow, CustomTable, TDPadding, PreferenceNumber };
